module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1181.bdc81eeb.png";